import React from 'react';
import styles from './landingFaq.module.css';

interface FaqContentProps {
  answer: string;
  isOpen: boolean;
}

const formatAnswer = (answer: string) =>
  answer.split('\n\n').map((paragraph, index) => (
    <React.Fragment key={paragraph}>
      {index > 0 && (
        <>
          <br />
          <br />
        </>
      )}
      {paragraph}
    </React.Fragment>
  ));

const FaqContent: React.FC<FaqContentProps> = ({ answer, isOpen }) => (
  <div
    className={`${styles.faqContentPanel} ${
      isOpen ? styles.faqContentPanelExpanded : styles.faqContentPanelCollapsed
    }`}
    aria-hidden={!isOpen}
  >
    <p className={styles.faqContent}>{formatAnswer(answer)}</p>
  </div>
);

export default FaqContent;
